module.exports = __webpack_public_path__ + "static/img/headimg.a4ec31a1.jpg";